import React from "react";
import { TextField, DateField, Datagrid, List, useListController } from "react-admin";
import { EmptyList } from "common/components";
import { dateOptions } from "utils/options";
import { reportDistrictsFirstSecondReferenceFilters, publishersEditionsFilters } from "../Filters";
import { DownloadTopToolbarButton } from "../../../../utils/customActions";
import { REPORT_DISCOUNT_POST_OFFICE_2 } from "../../Reports/ReportDisPostOffice2";
import { REPORT_EDITIONS } from "../../Reports/ReportEditions";

const EditionSecondRef = ({ dpo, reportDpoOptions, email }) => {
  let url = dpo ? `${REPORT_DISCOUNT_POST_OFFICE_2}/download` : `${REPORT_EDITIONS}/download`;
  let fileName = dpo ? "districts-second-reference" : "editions-reference";
  const { filterValues, page, perPage } = useListController();
  return (
    <List
      actions={
        <DownloadTopToolbarButton
          customResources={url}
          fileName={fileName}
          filterParams={{ filterValues, page, perPage }}
        />
      }
      filters={reportDpoOptions ? reportDistrictsFirstSecondReferenceFilters : publishersEditionsFilters}
      filterDefaultValues={{ start_year: "2024" }}
    >
      <Datagrid
        bulkActionButtons={false}
        empty={<EmptyList />}
      >
        <TextField
          label={dpo ? "ОПС" : "Издател"}
          source={dpo ? "district_post_office_name" : "publisher_name"}
          sortable={false}
        />
        <TextField
          label="Клиенти бр."
          source="receivers_quantity"
          sortable={false}
        />
        {dpo && (
          <TextField
            label="Код"
            source="code"
            sortable={false}
          />
        )}
        <TextField
          label="Издание"
          source="edition_title"
          sortable={false}
        />
        <TextField
          label="Кол."
          source="edition_quantity"
          sortable={false}
        />
        <TextField
          label="Обща Цена"
          source="total_sum"
          sortable={false}
        />
        {/* {email && (
            <TextField
              label="E-мейл за доставка на ел изд."
              source="receiving_edition_email"
              sortable={false}
            />
          )} */}
        <DateField
          label="Начало на абонамента"
          locales={"bg"}
          options={dateOptions}
          source="edition_start_date"
          sortable={false}
        />
        <TextField
          label="s_m1"
          source="first_month_quantity"
          sortable={false}
          style={{ width: "10px" }}
        />
        <TextField
          label="s_m2"
          source="second_month_quantity"
          sortable={false}
          style={{ width: "10px" }}
        />{" "}
        <TextField
          label="s_m3"
          source="third_month_quantity"
          sortable={false}
          style={{ width: "10px" }}
        />{" "}
        <TextField
          label="s_m4"
          source="fourth_month_quantity"
          sortable={false}
          style={{ width: "10px" }}
        />{" "}
        <TextField
          label="s_m5"
          source="fifth_month_quantity"
          sortable={false}
          style={{ width: "10px" }}
        />
        <TextField
          label="s_m6"
          source="sixth_month_quantity"
          sortable={false}
          style={{ width: "10px" }}
        />
        <TextField
          label="s_m7"
          source="seventh_month_quantity"
          sortable={false}
          style={{ width: "10px" }}
        />{" "}
        <TextField
          label="s_m8"
          source="eighth_month_quantity"
          sortable={false}
          style={{ width: "10px" }}
        />{" "}
        <TextField
          label="s_m9"
          source="ninth_month_quantity"
          sortable={false}
          style={{ width: "10px" }}
        />{" "}
        <TextField
          label="s_m10"
          source="tenth_month_quantity"
          sortable={false}
          style={{ width: "10px" }}
        />{" "}
        <TextField
          label="s_m11"
          source="eleventh_month_quantity"
          sortable={false}
          style={{ width: "10px" }}
        />{" "}
        <TextField
          label="s_m12"
          source="twelfth_month_quantity"
          sortable={false}
          style={{ width: "10px" }}
        />
      </Datagrid>
    </List>
  );
};
export default EditionSecondRef;
